<i18n lang='yml' src='./i18n/FroalaEditor.yml'></i18n>
<template>
  <div>
    <Field 
      :name="title" 
      :rules="isRequired ? 'required': undefined" 
      v-slot="{ errors, field }"
      v-model="model">
      <label class="description-label" :for="htmlfor">
        {{ title }}&nbsp; 
        <span v-if="isRequired" class='red'>*<span class="sr-only">{{$t('required')}}</span></span>
        
        <button class="accessible-information btn btn-primary btn-sm" :aria-label="$t('editor_text')" @click="openModal">{{$t('editor_text')}}</button>                  
      </label>
      <div class="froala-editor-wrapper" :class="{'is-invalid': errors[0]}">
        <!-- Can't use v-bind here as it causes an error similar to this https://github.com/froala/vue-froala-wysiwyg/issues/118 -->
        <froala :tag="'textarea'" :id="htmlfor" :config="config" v-model:value="model"/>
      </div>
      <div class="invalid-feedback" id="test_id_error" v-if="errors[0]">
        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
        <span>{{ errors[0] }}</span> 
      </div>
    </Field>  
  </div>
</template>

<script>
import { Field, Form } from 'vee-validate'
export default {
  components: {
    Form,
    Field
  },
  props: [
    'htmlfor',
    'isRequired',
    'text',
    'id',
    'title'
  ],
 
  data() {
    return {
      config: {
        heightMin: 200,
        pastePlain: true,
        toolbarSticky: false,
        iconsTemplate: 'font_awesome_5',
        language: $('html').attr('lang'),
        key: '6C4A4G4E3C3F3A4B-16D4E3D2E3C3I2E1B10C2E2pBKBOg1a2PQa1ERGRi1B==',
        paragraphFormat: 
          {  N: 'Normal',  H1: 'Heading 1',  H2: 'Heading 2',  H3: 'Heading 3',  H4: 'Heading 4', H5: 'Heading 5', H6: 'Heading 6',  PRE: 'Code'},
        attribution: false,
        toolbarButtons: [
          'checkbox',
          'fullscreen',
          'bold',
          'italic',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          'fontFamily',
          'fontSize',
          'textColor',
          'paragraphStyle',
          'paragraphFormat',
          'align',
          'formatOL',
          'formatUL',
          'outdent',
          'indent',
          'quote',
          'insertHR',
          'insertTable',
          'insertLink',
          'clearFormatting',
          'selectAll',
          'html',
          'help',
        ],
        charCounterCount: false,
        toolbarSticky: false
      },
      model: this.text,
    };
  },
  watch: {
    // whenever response changes, this function will run
    model(textchange) {
      this.$emit('setText', {text: this.model, id: this.id})
    }
  },
  methods: {
    openModal: function (e) {
      e.preventDefault()
      $('#modalAccessibleInformation').modal('show')
    }
    
  }

};
</script>
